// src/modules/profile/components/CompetitionsWonCard/index.js
import React from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { parseLocalDate } from '../../../../shared/utils/dateUtils';
import './styles.css';

const CompetitionsWonCard = ({ wonCompetitions }) => {
    return (
        <Card className="competitions-won-card">
            <Card.Header className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0">
                    <i className="bi bi-trophy-fill me-2 text-warning"></i>
                    Competitions Won
                </h5>
                <Badge bg="warning" text="dark">{wonCompetitions?.length || 0}</Badge>
            </Card.Header>
            <ListGroup variant="flush">
                {wonCompetitions && wonCompetitions.length > 0 ? (
                    wonCompetitions.map(comp => (
                        <ListGroup.Item key={comp.competitionId} className="p-0">
                            <Link to={`/competition/${comp.competitionId}`} className="comp-item-link">
                                <div className="comp-item">
                                    <div className="comp-info">
                                        <div className="comp-name">{comp.name}</div>
                                        {comp.endDate && (
                                            <div className="comp-meta text-muted">
                                                {parseLocalDate(comp.endDate).toLocaleDateString()}
                                            </div>
                                        )}
                                    </div>
                                    <div className="comp-points">
                                        <strong>{comp.points !== undefined && comp.points !== null ? comp.points.toFixed(1) : '0'}</strong> pts
                                    </div>
                                </div>
                            </Link>
                        </ListGroup.Item>
                    ))
                ) : (
                    <ListGroup.Item className="text-center text-muted py-4">
                        <i className="bi bi-trophy d-block mb-2" style={{ fontSize: '1.5rem' }}></i>
                        No competitions won yet
                    </ListGroup.Item>
                )}
            </ListGroup>
        </Card>
    );
};

CompetitionsWonCard.propTypes = {
    wonCompetitions: PropTypes.arrayOf(PropTypes.shape({
        competitionId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        points: PropTypes.number,
        endDate: PropTypes.string
    }))
};

export default CompetitionsWonCard;
